<template>
  <div class="content"> 
	<app-header></app-header>   
	<div class="preview">
		<div class="myResume">
                <div class="bsicResume">
                  <div class="myResumeBasicMsg">
                    <p class="clearfix nameTitle">
                      <span>{{pernalName}}
                    <span v-if = "resumesex =='男'" class="icon iconfont">&#xe694;</span>
                    <span v-if = "resumesex =='女'" class="icon iconfont">&#xe616;</span>
                  </span>
                    </p>
                    <p><span>生日：{{birthday}}</span>|<span>政治面貌：{{politicalStatus}}</span>|<span>民族：{{nationality}}</span>|<span>婚否：{{genders}}</span></p>
                <p><span>学历：{{resumeEdiu}}</span>|<span>专业：{{profession}}</span>|<span>外语：{{languages}}</span>|<span>毕业院校：{{graduated}}</span>|<span>职称：{{jobTitle}}</span></p>
                <p><span>电话：{{telPhone}}</span>|<span>邮箱：{{pernalEmail}}</span>|<span>地址：{{address}}|<span>籍贯：{{birthplace}}</span></span></p>
                <p><span>工资：{{expectedSalary}}</span>|<span>最快入职时间：{{entryTimes}}</span></p>
                <!-- <p><span>意向职位：{{resumeWant}}</span></p>
                    <p class="experience"><span>{{resumeYear}}年工作经验</span>| <span>{{resumeEdiu}}</span> | <span>{{ages}}岁</span> | <span>{{resumesex}}</span></p>
                    <p class="contact"><span>联系电话：{{telPhone}}</span><span>电子邮箱：{{pernalEmail}}</span></p> -->
                  </div>
              <div class="myResumeAva">
                <img  v-bind:src="avatarPhoto" alt="科研人才网-高校教师博士科研岗位人才招聘" />
              </div>
                </div>
                <div class="moreResume">
              <h3 class="clearfix"><span><i></i>教育背景</span></h3>
                  <div class="eduExperience" v-for = "(items,index) in educationList" :key="'index_'+index">
                    <p class="clearfix">{{items.schoolName}} {{items.education}} {{items.major}} {{items.researchDirection}} {{items.cultureType}}
                
                      <span class="fr">{{items.beginYeartime}}-{{items.beginMonthtime}} / {{items.endYeartime}}-{{items.endMonthtime}}</span>
                    </p>
                  </div>
                  <h3 class="clearfix"><span><i></i>工作/实践经历</span></h3>
                  <div v-for = "(items,index) in jobHistory" class="workExperience" :key="'index-'+index">
                    <h4 class="clearfix">{{items.companyName}}<span class="fr">{{items.beginYeartime}}-{{items.beginMonthtime}} / {{items.endYeartime}}-{{items.endMonthtime}}</span></h4>
                    <p>职位：{{items.job}} <span></span></p>
                    <p v-html = "items.description"></p>
                  </div>
              <h3 class="clearfix"><span><i></i>科研成果</span></h3>
                  <div class="workExperience">
                <p v-html = "achievements"></p>
                  </div>
              <h3 class="clearfix"><span><i></i>技能与证书</span></h3>
                  <div class="workExperience">
                <p v-html = "skillsCertificate"></p>
                  </div>
              <h3 class="clearfix"><span><i></i>荣誉或奖励</span></h3>
                  <div class="workExperience">
                <p v-html = "honorCertificate"></p>
                  </div>
              <h3 class="clearfix"><span><i></i>兴趣与特长</span></h3>
                  <div  class="workExperience">
                <p v-html = "interestAndExpertise"></p>
                  </div>
                </div>
              </div>
	</div>
	<app-footer style="position:absolute;bottom:0;width:100%"></app-footer>
  </div>
</template>
<script> 
import AppFooter from '../../components/common/footer.vue'
import AppHeader from '../../components/common/header1.vue'
import {get, postWithJson, form} from '@/api/services'
export default {
  name: 'preview',
  components: {AppFooter,AppHeader },
    data () {
    	return {
        sumeId:'',
			pernalName:'',		//姓名
			telPhone:'', 		//手机号
			pernalEmail:'', //邮箱
			address:'',	//通信地址
			politicalStatus:'',//政治面貌
			nationality:"",//民族
			birthplace:'',//籍贯
			genders:"未婚",//婚否
			graduated:'',//毕业院校
			profession:'',//专业
			languages:'',//外语水平
			jobTitle:'',//职称
			expectedSalary:'',//期待月薪
			entryTimes:'',//最快入职时间
			achievements:'',//科研成果
			skillsCertificate:"",//技能与证书
			honorCertificate:'',//荣誉与证书
			interestAndExpertise:'',//兴趣与特长
			introduction:'',//自我评价
			avatarPhoto:require("../../assets/imgs/personAvatar.png"),//上传头像地址
			userName:"",
			checkViewFlags:'true',
			newPsd:'',
			newPswAgin:'',
			applyNoreadList:"",//已投简历
			applyreadList:"",//已读简历
			rId:'',//简历id
			showMask:false,//遮罩是否显示
			showEditBasic:false, //编辑基本信息
			showThunting:false,//编辑求职状态
			showDes:false,//编辑自我描述
			showWork:false,//编辑工作经历
			showEdu:false,//编辑教育经历
			achievementsFlag:false,//科研成果
			skillsCertificateFlag:false,//技能与证书
			honorCertificateFlag:false,//荣誉与证书
			interestAndExpertiseFlag:false,//兴趣与特长
			introductionFlag:false,//自我评价
			// ThuntingStatus:"",//求职状态value
			resumeName:'',//简历姓名
			
			jobList:[],//职位列表
			
			resumeWant:'',//求职意向
			// resumeYear:'0',//工作年限
			resumeEdiu:'',//简历学历
			certificate:'',//证书
			certificateNo:'',//证书号码
			ages:'',//年龄
			birthday:'',
			resumesex:'男',//简历性别
			jobHistory:'',//工作经历列表
			editorText:"",//工作经历
			WorkId:'',//工作经历id
			comName:'',//公司名称
			comdepartment:'',//公司部门
			comJob:'',//公司职位
			comBeginTime:"",//工作经历 开始时间
			comEndTime:"",//工作经历 结束时间
			educationList:'',//教育经历
			educationId:'',//教育经历id
			schoolName:'',//学校名称
			schoolProf:'',//专业
			researchDirection:'',//研究方向
			cultureType:'',//培养类型
			schoolEducation:'',//学历
			realName:'',//身份证姓名
			idcardNo:'',//身份证号
			schoolBeginTime:'',//开始时间
			schoolEndTime:'',//结束时间
			verifiedCard:0,//身份认证是否通过
    	}
  	},
    created:function () {

	},

	methods:{
		setRead(){
      let _self = this;
      if(_self.$route.query.userId == undefined || _self.$route.query.userId == ""){
        this.$router.push({ path:'/login',query:{loginFlag:false}});
				return false;
      }
			postWithJson('front/userRecruit/updateUserRecruit',{id:_self.$route.query.id,isLook:2}).then(
				function(response) {
					console.log(response);
				},
				function(response) {
					_self.$message({
              message: response.data.message,
              type: 'error'
          });            
				}
      )
      postWithJson('front/resumeInfo/queryResumeInfo',{userId:_self.$route.query.userId,isLook:1}).then(
				function(response) {
					console.log(response)
						if(response.data.status){
							let dataList = response.data.data;
							if(dataList === null){return false;}
							// let _userId = dataList.userId;
							// sessionStorage.setItem('_userId', _userId);
							_self.sumeId = dataList.id;
							_self.graduated = dataList.school;
							_self.pernalName = dataList.positionName;
							_self.telPhone = dataList.mobile;
							_self.resumeEdiu = dataList.education;
							_self.birthday = dataList.birth;
							_self.avatarPhoto = dataList.photo||require("../../assets/imgs/personAvatar.png");
							_self.politicalStatus = dataList.politicalAppearance;
							_self.nationality = dataList.nation;
							_self.birthplace = dataList.nativePlace;
							_self.genders = dataList.maritalStatus;
							_self.address = dataList.address;
							_self.expectedSalary = dataList.hopeMoney;
							_self.entryTimes = dataList.arrivalTime;
							_self.languages = dataList.foreignLanguages;
							_self.jobHistory = dataList.resumeWorkList;
							_self.educationList = dataList.resumeStudyList;
							_self.skillsCertificate = dataList.skillsCertificate;
							_self.achievements = dataList.achievements;//科研成果
							_self.honorCertificate = dataList.honorCertificate;//荣誉与证书
							_self.interestAndExpertise = dataList.interestAndExpertise//兴趣与特长
						}else{
							_self.$message({
                                message: response.data.message,
                                type: 'error'
                            }); 
						}
				},
				function(response) {
					_self.$message({
              message: response.data.message,
              type: 'error'
          });            
				}
			)
    },
    // getUserInfo(_id){
    //   let _self = this;
    //     var reqData = {tel:_id} 
		// 		postWithJson('user/getUserInfo',reqData).then(
		// 			function(response) {
		// 				if(response.data.status){
		// 					let _userId = response.data.data.id;
		// 					_self.pernalName = response.data.data.name;		//姓名
		// 					_self.pernalEmail = response.data.data.email; //邮箱
		// 					_self.avatarPhoto = response.data.data.photo == ""?require("../../assets/imgs/personAvatar.png"):response.data.data.photo;
		// 				}else{
		// 					_self.$message({
		// 						message: response.data.message,
		// 						type: 'error'
		// 					}); 
		// 				}
		// 			},
		// 			function(response) {
		// 				_self.$message({
		// 					message: response.data.message,
		// 					type: 'error'
		// 				});           
		// 			}
		// 		)
    // }
	},
	mounted:function(){	
		this.setRead();
	},
	computed: {
			 
	},
	
}
</script>

<style  lang = "less"  scoped="scoped">
//滚动条
::-webkit-scrollbar {
    width: 6px;
    height: 6px;
    background-color: #f1f1f1;
}

//滚动条轨道 
::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 6px #f1f1f1;
    -moz-box-shadow: inset 0 0 6px #f1f1f1;
    box-shadow: inset 0 0 6px #f1f1f1;
    background-color: #f1f1f1;
}

//滑块
::-webkit-scrollbar-thumb {
    -webkit-box-shadow: inset 0 0 6px #c1c1c1;
    -moz-box-shadow: inset 0 0 6px #c1c1c1;
    box-shadow: inset 0 0 6px #c1c1c1;
    border-radius: 3px;
    background-color: #c1c1c1;
}
.page-bar i{
    font-style:normal;
    color: #1787FB;
    margin: 0px 4px;
    font-size: 12px;
}
.content{
    width: 100%;
    position: relative;
    min-height: 870px;
    background-color: #F4F8FF;
	overflow: hidden;
	.preview{
    /* margin-top: 120px; */
    width: 980px;
    margin: 40px auto 150px;
    background-color: #fff;
    min-height: 400px;
    box-shadow: 0 10px 10px #ddd;
  }
			.myResume{
				.bsicResume{
					background-color: #fff;
					height: 230px;
					box-sizing: border-box;
					padding-top: 40px;
					margin: 0 111px;
          position: relative;
					.myResumeAva{
						display: inline-block;
						vertical-align: top;
						margin:0 24px 0 58px;
            position: absolute;
            top: 80px;
            right: 20px;
						img{
							width: 70px;
							height: 100px;
						}
					}
					.myResumeBasicMsg{
						width: 640px;
						display: inline-block;
						padding-left: 20px;
						p{
							font-size: 14px;
							color: #444;
							height: 36px;
							line-height: 36px;
							span{
								margin:0 4px;
							}
						}
						.experience{
							span{
								margin-right: 4px;
							}
						}
						.contact{
							span{
								margin-right: 52px;
							}
						}
						.nameTitle{
							span{
								font-size: 24px;
								color: #444;
								font-weight: bold;
								.iconfont{
									display: inline-block;
									width: 26px;
									height: 26px;
									line-height: 26px;
									text-align: center;
									background-color: #7ca0f5;
									font-size: 16px;
									color: white;
									border-radius: 4px;
									margin-left: 10px;
								}
							}
							.certificateNameLogo{
								vertical-align: middle;
								display: inline-block;
								width: 26px;
								height: 26px;
								line-height: 26px;
								text-align: center;
								font-size: 12px;
								margin-left: 4px;
								border-radius: 4px;
								color:white;
								position: relative;
								img{
									width: 26px;
									height: 26px;
								}
								.tips{
									position: absolute;
									bottom: -44px;
									font-size: 12px;
									border-radius: 4px;
									width: 160px;
									line-height: 30px;
									height: 30px;
									left:-68px;
									display: none;
									background-color: bisque;
									.theBlockquote{
										position: absolute;
										top: -16px;
										left: 50%;
										margin-left: -8px;
										width:0;
										height:0;
										border-left:10px solid transparent;
										border-right:10px solid transparent;
										border-bottom:20px solid bisque;
									}
								}
							}
							.certificateNameLogo:hover .tips{
								display: block;
							}
						}
					}
				}
				.moreResume{
					padding: 0 111px 20px;
					box-sizing: border-box;
					h3{
						font-size: 20px;
						color: #666666;
						height: 54px;
						line-height: 54px;
						border-top: 1px solid #e5e5e5;
						margin-top: 18px;
						span{
							vertical-align: middle;
						}
						i{
							vertical-align: middle;
							display: inline-block;
							height: 20px;
							width: 2px;
							background-color: #1787FB;
							margin-right: 14px;
							margin-top: -4px;
						}
						.fr{
							color: #1787FB;
							font-size: 16px;
							font-weight: normal;
							cursor: pointer;
							.iconfont{
								font-size: 24px;
								margin-right: 4px;
							}
						}
					}
					.huntingSatus{
						P{
							text-indent: 20px;
							line-height: 30px;
						}
					}
					.myDescription{
						p{
							text-indent: 20px;
							line-height: 30px;
						}
					}	
					.workExperience{
							font-size: 16px;
							color: #444;
							p{
								line-height: 30px;
							}
							.fr{
								font-weight: normal;
							}						
					}
					.eduExperience{
						padding-bottom: 30px;
						/* border-bottom: 1px solid #ddd; */
						p{
							text-indent: 20px;
							line-height: 30px;
						}
					}
					.authentication{
						padding-bottom: 40px;
						.inputvauthentication{
							input{
								width: 400px;
								height: 44px;
								border: none;
								background-color: #f8f8f8;
								margin-left: 20px;
								text-indent: 10px;
								font-size: 16px;
							}
							span{
								display: inline-block;
								width: 104px;
								text-align: center;
								height: 44px;
								line-height: 44px;
								color: white;
								background-color: #1787FB;
								font-size: 16px;
								margin-left: 10px;
								cursor: pointer;
								letter-spacing: 6px;
							}
						}
					}
					.documentCertification{
						padding-bottom: 40px;
						p{
							select{
								height: 40px;
								width: 180px;
								border: none;
								background-color: #f8f8f8;
								margin-left: 20px;
								text-indent: 10px;
							}
							input{
								width: 300px;
								height: 44px;
								border: none;
								background-color: #f8f8f8;
								margin-left: 10px;
								text-indent: 10px;
								font-size: 16px;
							}
							select{
								font-size: 16px;
							}
							span{
								display: inline-block;
								width: 104px;
								text-align: center;
								height: 44px;
								line-height: 44px;
								color: white;
								background-color: #1787FB;
								font-size: 16px;
								margin-left: 10px;
								cursor: pointer;
								letter-spacing: 6px;
							}
						}
						.hasCertification{
							text-indent: 20px;
							font-size: 16px;
							height: 24px;
							line-height: 24px;
							i{
								font-style: normal;
								color: #1787FB;
								margin-left: 10px;
							}
						}
					}
					
				}
			}
			.myDelivery{
				.deliveryTab{
					height: 60px;
					line-height: 60px;
					box-sizing: border-box;
					border-bottom: 1px solid #e5e5e5;
					span{
						float: left;
						display: inline-block;
						height: 100%;
						width: 140px;
						text-align: center;
						cursor: pointer;
						border-bottom: 2px solid transparent;
					}
					.checkViewFlag{
						border-bottom:2px solid #1787FB;
					}
				}
				.deliverySucess,.beingViewed{
					padding: 12px;
					.companyMsg{
						height: 60px;
						width: 100%;
						overflow: hidden;
						margin-top: 16px;
						border: 1px solid #dde2ea;
						.positions{
							width: 450px;
							height: 100%;
							border-right: 1px dashed #dde2ea;
							padding: 20px 30px 20px 20px;
							box-sizing: border-box;
							.positionsName{
								.fl{
									font-weight: bold;
									font-size: 16px;
									color: #444;
								}
								.fr{
									font-size: 16px;
									color: #e77817;
								}
							}
							.positions-detail{
								color: #878787;
								font-size: 14px;
								/* border-bottom: 1px dashed #d4dae4;
								padding: 20px 0; */
								span{
									display: inline-block;
									width: 50%;
								}
							}
							.positionsDuties{
								font-size: 14px;
								color: #878787;
								margin-top: 14px;
								i{
									font-style: normal;
									display: inline-block;
									width: 72px;
								}
								span{
									display: inline-block;
									width: 290px;
									text-overflow: -o-ellipsis-lastline;
									overflow: hidden;
									text-overflow: ellipsis;
									display: -webkit-box;
									-webkit-line-clamp: 2;
									-webkit-box-orient: vertical;
								}
							}
						}
						.companyContent{
							width: 540px;
							height: 100%;
							padding: 20px;
							box-sizing: border-box;
							/*../../assets/images/LOGOThumbnail.png*/
							.companyLogo{
								display: inline-block;
								height: 100%;
								width: 118px;
								img{
									width: 72px;
									height: 66px;
									margin-top: 7px;
									margin-left: 23px;
								}
							}
							.company{
								display: inline-block;
								width: 410px;
								.companyName{
									color: #1787FB;
									i{
										font-style: normal;
										font-size: 16px;
										color: #444444;
										font-weight: bold;
									}
									span{
										display: inline-block;
										width: 270px;
										font-size: 12px;
										color: #878787;
									}
								}
								.companyPlace,.companyWelfare{
									color: #444;
									font-size: 12px;
									margin: 4px 0;
								}
							}
						}
					}
					
				}
			}
			.systemMsg{
				height: 120px;
				width: 100%;
				overflow: hidden;
				margin-top: 16px;
				border: 1px solid #dde2ea;
				.sysMsg{
					padding: 10px;
					.contentMsg{
						color: #878787;
						font-size: 13px;
					}
				}
			}
			.systemMsg:hover{
				box-shadow: 0 0 10px #999;
			}
			
			.changePassword{
				text-align: left;
				padding-top: 52px;
				p{
					width: 428px;
					height: 74px;
					line-height: 74px;
					margin: 0 auto;
					border-bottom: 1px solid #d5dbe5;
					font-size: 16px;
					color: #444;
					box-sizing: border-box;
					input{
						font-size: 16px;
						height: 90%;
						width: 100%;
						outline: none;
						border: none;
					}
				}
				.saveMsg{
					border: none;
					text-align: center;
					span{
						display: inline-block;
						width: 428px;
						height: 52px;
						background-color: #1787FB;
						color: white;
						line-height: 52px;
						margin-top: 20px;
						cursor: pointer;
					}
				}
			}
	
			
}

</style>



// WEBPACK FOOTER //
// src/views/companyRegister/positionsDetail.vue